/**
 * 文字列の判定、バリデーション関連の共通メソッド群
 */
export default class StringUtils {
  /**
   * 指定文字列の存在判定
   *
   * @param str 文字列
   * @returns 指定文字列がundefined, null, 空文字, 空白の場合true
   */
  public static isBlank(str: string | null | undefined): boolean {
    return !str || str.trim().length === 0
  }
}
